module.exports = App.MapContainerMixin = Ember.Mixin.create
  _childLayers: null
  init: ->
    @_super.apply this, arguments
    @set '_childLayers', new Ember.A
    return
  registerChild: (childLayer) ->
    @_childLayers.addObject childLayer
    #If container already setup setup child immediatly
    if @_layer
      childLayer.layerSetup()
    return
  unregisterChild: (childLayer) ->
    @_childLayers.removeObject childLayer
    #If container already setup teardown child immediatly
    if @_layer
      childLayer.layerTeardown()
    return